import { SET_TEAMS } from '../actions/actionTypes';

const initialState = {
  list: [],
  loading: false,
};

const teamsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TEAMS:
      return { ...state, loading: false, list: action.teams };
    default:
      return state;
  }
};

export default teamsReducer;
